import { useEffect, useState } from 'react'
import { flushSync } from 'react-dom'

import { ItemInterface, ReactSortable } from 'react-sortablejs'

import { useMutation } from '@apollo/client'
import NoSSR from 'Root/Component/NoSSR'
import findIndex from 'lodash/findIndex'
import map from 'lodash/map'

import Module from '../Module'
import MUTATION from './change-collection-modules-order.graphql'

const SortableModuleWrapper = ({
  collectionId,
  modules,
  canReadCollection,
  canManageCollection,
  refetchOnUpdate,
  visibility,
  collectionSlug,
}) => {
  const [mutate] = useMutation(MUTATION)

  const [state, setState] = useState<ItemInterface[]>(
    map(modules || [], ({ id }) => ({ id }))
  )

  useEffect(() => {
    // used to update the modules list when one is added or deleted
    setState(map(modules || [], ({ id }) => ({ id })))
  }, [modules])

  // https://github.com/SortableJS/react-sortablejs/issues/263
  const setListSync = (newSteps, sortable) => {
    if (sortable) {
      // flushSync required for this to work in React 18
      flushSync(() => setState(newSteps))
    } else {
      // called from component constructor, where flushSync throws error
      setState(newSteps)
    }
  }

  const onEnd = () => {
    const modulesId = map(state, 'id') as string[]

    mutate({
      variables: {
        id: collectionId,
        modulesId,
      },
    })
  }

  const existingModulesId = state.filter((obj) => {
    return findIndex(modules || [], ['id', obj.id]) != -1
  })

  return (
    <NoSSR>
      <ReactSortable
        animation={500}
        className="flex flex-col gap-y-3"
        delay={500}
        delayOnTouchOnly
        ghostClass="opacity-0"
        list={existingModulesId}
        onEnd={onEnd}
        setList={setListSync}
      >
        {map(existingModulesId, ({ id }) => (
          <Module
            module={modules[findIndex(modules || [], ['id', id])]}
            canManage={canManageCollection}
            canReadCollection={canReadCollection}
            key={id}
            collectionSlug={collectionSlug}
            refetchOnUpdate={refetchOnUpdate}
            collectionId={collectionId}
            visibility={visibility}
            openOnStart={false}
          />
        ))}
      </ReactSortable>
    </NoSSR>
  )
}

export default SortableModuleWrapper
